import React, { useState } from "react";
import Im from "immutable";
import {
  usePostCache,
  fetcher,
} from "@action.sustainability/storybook-dashboard/utils/fetching";
import Octicon from "react-octicon";
import Papa from "papaparse";
import { Modal, useModal } from "../modal";
import { formEventToData } from "./invite";

const sendSiteInvites = (e, props) => {
  const { data, setPending, companyId } = props;
  setPending(true);

  fetcher("/api/tenant/admin/dispatch/", "POST", {
    type: "SEND_PROJECT_INVITES",
    payload: {
      company_id: companyId,
      invites: data.toJS(),
    },
  }).then(({ payload }) => {
    setPending(false);
    location.reload();
  });
};

function PendingInviteTableRow({ invite, onDeleteHandler }) {
  return (
    <tr>
      <td>{invite?.get("Email")}</td>
      <td>{invite?.get("Company Name")}</td>
      <td className="text-right">
        <span style={{ cursor: "pointer" }} onClick={onDeleteHandler}>
          Delete
        </span>
      </td>
    </tr>
  );
}

function AddSingleInviteForm({ data, setData }) {
  const onSubmit = (e) => {
    const invite = formEventToData(e);
    setData(data.push(Im.fromJS(invite)));
  };

  return (
    <form className="form-inline row" onSubmit={onSubmit}>
      <div className="col-5">
        <input
          type="email"
          name="Email"
          placeholder="Email"
          className="form-control form-control-sm"
        />
      </div>
      <div className="col-6">
        <input
          name="Company Name"
          placeholder="Company Name"
          className="form-control form-control-sm"
        />
      </div>
      <div className="col-1">
        <button
          type="submit"
          className="btn btn-sm btn-primary pt-0 pb-0 ml-1 mr-1 mb-2 float-right"
        >
          Add
        </button>
      </div>
    </form>
  );
}

function PendingInviteTable({ fields, data, setData, errors }) {
  const initNewData = fields.reduce(
    (acc, cur) => acc.set(cur.get("header"), ""),
    Im.Map(),
  );
  const [newData, setNewData] = useState(initNewData);

  let rows = data.map((invite, i) => (
    <PendingInviteTableRow
      key={i}
      invite={invite}
      onDeleteHandler={() => setData(data.delete(i))}
    />
  ));
  if (errors) {
    rows = rows.sortBy((row, index) => errors.get(index.toString()));
  }

  return (
    <div className="scrollTopContainer m-0 p-0" style={{ overflowX: "auto" }}>
      <table width="100%" className="table table-sm scrollTopContent m-0 p-0">
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}

function SendInvitesButton(props) {
  const { pending, metaFields } = props;
  return (
    <button
      disabled={pending}
      className="btn btn-sm btn-primary pt-0 pb-0 ml-1 mr-1 mb-2 float-right"
      onClick={(e) => sendSiteInvites(e, { ...props })}
    >
      {pending ? (
        <div
          className="spinner-border spinner-border-sm text-light"
          role="status"
        />
      ) : (
        "Send Invites"
      )}
    </button>
  );
}

function UploadFromCSVButton({ data, setData }) {
  return (
    <button
      className="btn btn-sm btn-primary pt-0 pb-0 ml-1 mr-1 mb-2"
      onClick={(e) => {
        e.preventDefault();
        $("#file-selector").on("change", (e) => {
          Papa.parse(e.target.files[0], {
            complete: (results) => {
              const headers = results.data[0];
              // console.log("FOUND CSV HEADERS", headers)
              const newData = results.data
                .slice(1)
                .map((row) =>
                  headers.reduce(
                    (acc, cur, i) => Object.assign(acc, { [cur]: row[i] }),
                    {},
                  ),
                );
              // console.log("GOT CSV DATA", newData)
              if (
                newData[newData.length - 1] &&
                !newData[newData.length - 1].Email
              ) {
                newData.pop();
              }
              setData(data.concat(Im.fromJS(newData)));
            },
          });
        });
        $("#file-selector").trigger("click");
      }}
    >
      Upload from CSV
    </button>
  );
}

function Errors({ errors }) {
  if (!errors || !errors.size) {
    return null;
  }

  if (Im.isList(errors)) {
    return (
      <div className="text-danger mb-2">
        <div>Could not send project invitations.</div>
        <div>{errors.toJS()}</div>
      </div>
    );
  }

  return (
    <div className="text-danger mb-2">
      Could not send project invitations. See errors below
    </div>
  );
}

export function SiteInviteModal(props) {
  const { errors, companyId } = props;
  const [pending, setPending] = useState(false);
  const [fields, setFields] = useState(
    Im.fromJS([{ header: "Email" }, { header: "Company Name" }]),
  );
  const [metaFields, setMetaFields] = useState({
    template_project: null,
    supplier_holding_company: null,
  });
  const [data, setData] = useState(Im.List());

  return (
    <Modal title="Invite your suppliers">
      <div className="row">
        <div className="col-12">
          <p>
            {" "}
            Please upload a CSV file containing the list of suppliers you wish
            to invite to the platform. Your file must include two column
            headers: "Email" and "Company Name." Once your suppliers are
            invited, they will gain free access to the platform to report on the
            embodied carbon footprint of their assets and products and share
            this information with you.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <UploadFromCSVButton data={data} setData={setData} />
        </div>

        <div className="col">
          <SendInvitesButton
            companyId={companyId}
            data={data}
            metaFields={metaFields}
            pending={pending}
            setPending={setPending}
          />
        </div>
      </div>
      <input style={{ display: "none" }} type="file" id="file-selector" />
      <Errors errors={errors} />
      <hr className="mt-1 mb-1" />
      <AddSingleInviteForm data={data} setData={setData} />
      {/* <MetaFields fields={metaFields} setFields={setMetaFields} /> */}
      <PendingInviteTable
        fields={fields}
        data={data}
        setData={setData}
        errors={errors}
      />
      <hr />
    </Modal>
  );
}

function SiteInviteRow({ invite, hideAdmin }) {
  return (
    <tr>
      <td>{invite.get("email")}</td>
      <td>{invite.get("status")}</td>
      <td className="text-right">
        {hideAdmin ? null : (
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={(e) => {
              deleteSiteInvite(invite);
            }}
          >
            Delete
          </button>
        )}
      </td>
    </tr>
  );
}

function SiteInviteList({ companyId }) {
  const { data, isLoading } = usePostCache(
    `/api/company/${companyId}/dispatch/`,
    { type: "SITE_INVITE_LIST" },
  );
  const invites = data?.get("payload");
  console.log("SiteInviteList", invites?.toJS());

  if (!invites?.size) {
    return <p className="text-center">No invites to suppliers yet</p>;
  }
  return (
    <table className="table mb-5">
      <thead>
        <tr>
          <th scope="col">Email</th>
          <th scope="col">Status</th>
          <th scope="col" className="text-right">
            Admin
          </th>
        </tr>
      </thead>
      <tbody>
        {invites.map((invite, i) => (
          <SiteInviteRow key={i} invite={invite} />
        ))}
      </tbody>
    </table>
  );
}

export function SiteInviteButton({ companyId }) {
  const { setModal } = useModal();

  return (
    <>
      <button
        className="btn btn-sm btn-primary float-right mb-3"
        onClick={() => setModal(<SiteInviteModal companyId={companyId} />)}
      >
        Invite suppliers <Octicon className="ml-2 pt-1" name="plus" />
      </button>
      <div style={{ clear: "both" }} />
    </>
  );
}

export default function SiteInvitePanel({ companyId }) {
  return (
    <>
      <SiteInviteButton companyId={companyId} />
      <h5 className="font-weight-bold">Supplier invitations</h5>
      <SiteInviteList companyId={companyId} />
    </>
  );
}
